import { createStore, applyMiddleware } from "redux";
import { liveSwitchMiddleware } from "../../LiveSwitch/liveSwitchMiddleware";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
///@ts-ignore
import logger from "redux-logger";

export default function configureStore(initialState) {
    return createStore(rootReducer, initialState, applyMiddleware(thunk, liveSwitchMiddleware, logger));
}
